import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { fieldSimplified } from 'src/app/_interfaces/formDataSimplified';
import { MaterialFormModule } from 'src/app/_shared/material/material-form.module';
import { GroupedMultiselectComponent } from '../grouped-multiselect/grouped-multiselect.component';

@Component({
  selector: 'app-multi-select-option',
  templateUrl: './multi-select-option.component.html',
  styleUrls: ['./multi-select-option.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialFormModule, MatSelectModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectOptionComponent),
      multi: true,
    },
  ],
})
export class MultiSelectOptionComponent implements ControlValueAccessor {
  @Input() field: any;
  dataArray: any = [];
  ngOnChanges() {
    console.log(this.field);
  }
  private onChange = (value: any) => {};
  private onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    if (value) {
      this.dataArray = value;
    }
  }
  toggleSelection() {
    this.onChange(this.dataArray);
    this.onTouched();
  }
}
